import React from 'react';

import './ViolationSkeletons.scss';

export const ViolationStatsSkeleton = () => (
  <div className="att-violation-stats att-violation-stats--skeleton" aria-hidden>
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className="att-violation-stats__card">
        <span className="att-violation-skeleton__bar att-violation-skeleton__bar--label" />
        <span className="att-violation-skeleton__bar att-violation-skeleton__bar--value" />
      </div>
    ))}
  </div>
);

export const ViolationListSkeleton = ({ rows = 6 }) => (
  <div
    className="att-violation-skeleton att-violation-skeleton--list"
    aria-label="Loading violations"
  >
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="att-violation-skeleton__item">
        <span className="att-violation-skeleton__avatar" />
        <div className="att-violation-skeleton__content">
          <span className="att-violation-skeleton__bar att-violation-skeleton__bar--name" />
          <span className="att-violation-skeleton__bar att-violation-skeleton__bar--role" />
        </div>
        <span className="att-violation-skeleton__bar att-violation-skeleton__bar--badge" />
        <span className="att-violation-skeleton__chevron" />
      </div>
    ))}
  </div>
);

export const ViolationWidgetSkeleton = ({ rows = 5 }) => (
  <ul
    className="att-violation-skeleton att-violation-skeleton--widget"
    aria-label="Loading violations"
  >
    {Array.from({ length: rows }).map((_, i) => (
      <li key={i} className="att-violation-skeleton__widget-row">
        <span className="att-violation-skeleton__avatar att-violation-skeleton__avatar--sm" />
        <div className="att-violation-skeleton__content">
          <span className="att-violation-skeleton__bar att-violation-skeleton__bar--name" />
          <span className="att-violation-skeleton__bar att-violation-skeleton__bar--role" />
          <div className="att-violation-skeleton__chips">
            <span className="att-violation-skeleton__bar att-violation-skeleton__bar--chip" />
            <span className="att-violation-skeleton__bar att-violation-skeleton__bar--chip" />
          </div>
        </div>
        <span className="att-violation-skeleton__chevron att-violation-skeleton__chevron--btn" />
      </li>
    ))}
  </ul>
);
